import useWindowDimensions from './useWindowDimensions';

export default function useIsMobile() {
  const dimensions = useWindowDimensions();
  return dimensions && dimensions.width <= 1024;
}
